import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StatusService {
  private baseUrl = 'http://localhost:3000/processR';

  constructor(private http: HttpClient) { }

  processRound(batch: string) {
    return this.http.post<{ processId: string }>(
      `${this.baseUrl}/process-round?batch=${batch}`,
      {}
    );
  }

  pollStatus(processId: string) {
    return interval(2000).pipe(
      switchMap(() =>
        this.http.get<{ processId: string; status: string }>(
          `${this.baseUrl}/status/${processId}`
        )
      )
    );
  }
}
